'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var mapValues = exports.mapValues = function mapValues(object, iteratee) {
  var result = {};

  Object.keys(object).forEach(function (key) {
    return result[key] = iteratee(object[key], key, object);
  });

  return result;
};

var pickBy = exports.pickBy = function pickBy(object, predicate) {
  var result = {};

  Object.keys(object).forEach(function (key) {
    var value = object[key];

    if (predicate(value, key)) {
      result[key] = value;
    }
  });

  return result;
};

var createQueryRef = exports.createQueryRef = function createQueryRef(ref, query) {
  return Object.keys(query).reduce(function (queryRef, key) {
    var value = query[key];
    var args = Array.isArray(value) ? value : [value];

    return queryRef[key].apply(queryRef, _toConsumableArray(args));
  }, ref);
};

var getDisplayName = exports.getDisplayName = function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
};

var mapSnapshotToValue = exports.mapSnapshotToValue = function mapSnapshotToValue(snapshot) {
  var result = {};

  snapshot.forEach(function (child) {
    result[child.key] = child.val();
  });

  return result;
};